import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/base/SEOHead';
import { localBusinessSchema, buildBreadcrumbSchema, buildGraphSchema } from '@/components/base/schemas';
import { Link } from 'react-router-dom';

const breadcrumbSchema = buildBreadcrumbSchema([
  { name: 'Accueil', item: 'https://fenetre-paris15.fr/' },
  { name: 'Mentions légales', item: 'https://fenetre-paris15.fr/mentions-legales/' },
]);

export default function MentionsLegalesPage() {
  return (
    <Layout>
      <SEOHead
        title="Mentions légales | DF PRO — Réparation Fenêtre Paris 15"
        description="Mentions légales du site fenetre-paris15.fr — DF PRO, réparation de fenêtres, volets et baies vitrées à Paris 15."
        canonicalUrl="https://fenetre-paris15.fr/mentions-legales/"
        schema={buildGraphSchema(localBusinessSchema, breadcrumbSchema)}
      />

      {/* Breadcrumb */}
      <div className="bg-brand-mint/30 py-3">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav aria-label="Fil d'Ariane" className="text-xs text-brand-text/60">
            <Link to="/" className="hover:text-brand-accent">Accueil</Link><span className="mx-2">/</span><span className="text-brand-accent font-medium">Mentions légales</span>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl font-bold text-brand-dark mb-12" style={{ fontFamily: '"Playfair Display", serif' }}>Mentions légales</h1>

          <div className="space-y-10 text-brand-text/70 leading-relaxed">

            {/* 1. Éditeur du site */}
            <article>
              <h2 className="font-heading text-xl font-bold text-brand-dark mb-4">1. Éditeur du site</h2>
              <p className="mb-3">
                Le site <strong>fenetre-paris15.fr</strong> est édité par :
              </p>
              <ul className="space-y-2 list-none pl-0">
                <li><strong>Dénomination :</strong> DF PRO</li>
                <li><strong>Forme juridique :</strong> SAS</li>
                <li><strong>Adresse du siège social :</strong> DF PRO, 100 ROUTE DE NIMES 30132 CAISSARGUES</li>
                <li><strong>SIRET :</strong> 98477526200020</li>
                <li><strong>Téléphone :</strong> 01 87 66 81 55</li>
                <li><strong>Email :</strong> info@dfpro.fr</li>
                <li><strong>Directeur de la publication :</strong> DFPRO SAS</li>
              </ul>
            </article>

            {/* 2. Hébergement */}
            <article>
              <h2 className="font-heading text-xl font-bold text-brand-dark mb-4">2. Hébergement</h2>
              <ul className="space-y-2 list-none pl-0">
                <li><strong>Hébergeur du site :</strong> OVH SAS</li>
                <li><strong>Adresse de l'hébergeur :</strong> 2 rue Kellermann 59100 Roubaix</li>
              </ul>
            </article>

            {/* 3. Propriété intellectuelle */}
            <article>
              <h2 className="font-heading text-xl font-bold text-brand-dark mb-4">3. Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus du site (textes, images, logo DF PRO) est protégé par le droit d'auteur. Toute reproduction, représentation, modification, adaptation ou exploitation, totale ou partielle, sans autorisation préalable écrite de DF PRO est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
              </p>
            </article>

            {/* 4. Données personnelles (RGPD) */}
            <article>
              <h2 className="font-heading text-xl font-bold text-brand-dark mb-4">4. Données personnelles (RGPD)</h2>
              <p className="mb-3">
                Les données personnelles saisies dans les formulaires de devis et de contact présents sur ce site (nom, téléphone, email, adresse, message) sont utilisées <strong>uniquement</strong> pour traiter les demandes des utilisateurs.
              </p>
              <p className="mb-3">
                Elles ne sont <strong>ni vendues ni cédées à des tiers</strong>.
              </p>
              <p className="mb-3">
                Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, l'utilisateur dispose d'un droit d'accès, de rectification, d'opposition, d'effacement (« droit à l'oubli ») et de portabilité de ses données personnelles.
              </p>
              <p>
                Pour exercer ces droits, adressez votre demande par email à <strong>info@dfpro.fr</strong> ou par courrier à l'adresse du siège social indiquée en section 1. Une réponse vous sera apportée dans un délai maximal de 30 jours. En l'absence de réponse satisfaisante, vous pouvez introduire une réclamation auprès de la <strong>CNIL</strong> (www.cnil.fr).
              </p>
            </article>

            {/* 5. Cookies */}
            <article>
              <h2 className="font-heading text-xl font-bold text-brand-dark mb-4">5. Cookies</h2>
              <p>
                Le site utilise des cookies strictement nécessaires à son fonctionnement. [À COMPLÉTER si outils de mesure d'audience type Google Analytics utilisés.]
              </p>
            </article>

          </div>
        </div>
      </section>
    </Layout>
  );
}